export function getSubString(string, lastDigitCount) {
  let subString = string.substr(string.length - lastDigitCount);

  return subString;
}
